(() => {
  let fromMenu = false;

  window.addEventListener('click', (event) => {
    fromMenu = false;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('header-drawer a[href], header-menu a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target.toLowerCase() !== '_self')) return;

    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin) return;
    if (destination.pathname === location.pathname && destination.search === location.search) return;
    fromMenu = true;
  });

  window.addEventListener('pageswap', (event) => {
    if (fromMenu && event.viewTransition) document.documentElement.classList.add('zippopiu-menu-leaving');
    fromMenu = false;
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted || !document.documentElement.classList.contains('zippopiu-menu-leaving')) return;
    const drawer = document.querySelector('header-drawer');
    const details = drawer?.mainDetailsToggle;
    if (details?.open) {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      details.querySelectorAll('details').forEach((item) => {
        item.removeAttribute('open');
        item.classList.remove('menu-opening');
        item.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
      details.querySelectorAll('.submenu-open').forEach((item) => item.classList.remove('submenu-open'));
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      drawer.closest('.section-header')?.classList.remove('menu-open');
      document.body.classList.remove(`overflow-hidden-${drawer.dataset.breakpoint}`);
      window.removeEventListener('resize', drawer.onResize);
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
    }
    document.documentElement.classList.remove('zippopiu-menu-leaving');
  });
})();
